export function areSetsEqual(setOne, setTwo) {
    return setOne.size === setTwo.size && Array.from(setOne).every(element => setTwo.has(element));
}
